export const theme = {
  color: {
    appBg: "#1b1e2f",
    panel: "#292d40",
    surface: "#25293a",
    surfaceMuted: "#202437",
    tableHead: "#3a3a52",
    tableRow: "#30344a",
    tableRowAlt: "#2b3045",
    tableRowHover: "#3b4059",
    dropdown: "#2d3146",
    chip: "#424861",
    chipMuted: "#3d425b",
    button: "#35364d",
    buttonHover: "#42445f",
    itemHover: "#3a3f58",
    itemActive: "#3f4560",
    text: "#f8fafc",
    textSoft: "#eef2ff",
    textMuted: "#dbe3f0",
    placeholder: "#aab2c5",
    disabledText: "#8f9bad",
    primary: "#2563eb",
    focus: "#60a5fa",
  },
  border: {
    subtle: "rgba(226, 232, 240, 0.14)",
    default: "rgba(226, 232, 240, 0.22)",
    strong: "rgba(226, 232, 240, 0.28)",
    panel: "rgba(226, 232, 240, 0.18)",
    hover: "rgba(226, 232, 240, 0.42)",
    table: "rgba(148, 163, 184, 0.26)",
  },
  overlay: "rgba(14, 17, 30, 0.72)",
  fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

export const themeCssVars = `
  --ace-app-bg: ${theme.color.appBg};
  --ace-panel: ${theme.color.panel};
  --ace-surface: ${theme.color.surface};
  --ace-surface-muted: ${theme.color.surfaceMuted};
  --ace-table-head: ${theme.color.tableHead};
  --ace-table-row: ${theme.color.tableRow};
  --ace-table-row-alt: ${theme.color.tableRowAlt};
  --ace-table-row-hover: ${theme.color.tableRowHover};
  --ace-dropdown: ${theme.color.dropdown};
  --ace-chip: ${theme.color.chip};
  --ace-chip-muted: ${theme.color.chipMuted};
  --ace-button: ${theme.color.button};
  --ace-button-hover: ${theme.color.buttonHover};
  --ace-item-hover: ${theme.color.itemHover};
  --ace-item-active: ${theme.color.itemActive};
  --ace-text: ${theme.color.text};
  --ace-text-soft: ${theme.color.textSoft};
  --ace-text-muted: ${theme.color.textMuted};
  --ace-placeholder: ${theme.color.placeholder};
  --ace-disabled-text: ${theme.color.disabledText};
  --ace-primary: ${theme.color.primary};
  --ace-focus: ${theme.color.focus};
  --ace-border-subtle: ${theme.border.subtle};
  --ace-border: ${theme.border.default};
  --ace-border-strong: ${theme.border.strong};
  --ace-border-panel: ${theme.border.panel};
  --ace-border-hover: ${theme.border.hover};
  --ace-border-table: ${theme.border.table};
  --ace-overlay: ${theme.overlay};
  --ace-font-family: ${theme.fontFamily};
`;
